module.exports = __webpack_public_path__ + "static/media/01.bb42f475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kenya/01.jpg
// module id = 477
// module chunks = 0